/**
 * Status-light helpers for WhatsApp cloud-hosting inboxes.
 * tone: ok (green) | warn (amber) | bad (red) | neutral (slate)
 */
export const hostingToneDotClass = tone => {
  switch (tone) {
    case 'ok':
      return 'bg-n-teal-9';
    case 'warn':
      return 'bg-n-amber-9';
    case 'bad':
      return 'bg-n-ruby-9';
    default:
      return 'bg-n-slate-6';
  }
};

export const hostingConnectionOf = inbox => {
  if (!inbox) return null;
  if (inbox.channel_hosting_connection) return inbox.channel_hosting_connection;
  const attrs = inbox.additional_attributes || {};
  const isHosting =
    attrs.channel_hosting === true || attrs.channel_hosting_kind === 'linked_device';
  if (!isHosting) return null;
  return { status: 'unknown', tone: 'neutral', circuit_open: false };
};

export const hostingStatusTooltipKey = connection => {
  if (!connection) return null;
  if (connection.circuit_open) return 'CHANNEL_HOSTING.STATUS_LIGHT.CIRCUIT';
  const status = connection.status || 'unknown';
  const map = {
    connected: 'CHANNEL_HOSTING.STATUS_LIGHT.CONNECTED',
    pairing: 'CHANNEL_HOSTING.STATUS_LIGHT.PAIRING',
    pending: 'CHANNEL_HOSTING.STATUS_LIGHT.PENDING',
    disconnected: 'CHANNEL_HOSTING.STATUS_LIGHT.DISCONNECTED',
    error: 'CHANNEL_HOSTING.STATUS_LIGHT.ERROR',
    unknown: 'CHANNEL_HOSTING.STATUS_LIGHT.UNKNOWN',
  };
  return map[status] || 'CHANNEL_HOSTING.STATUS_LIGHT.UNKNOWN';
};
